import { render } from "./HSKCourses.vue?vue&type=template&id=0d5f8535&scoped=true"
import script from "./HSKCourses.vue?vue&type=script&lang=js"
export * from "./HSKCourses.vue?vue&type=script&lang=js"

import "./HSKCourses.vue?vue&type=style&index=0&id=0d5f8535&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5f8535"]])

export default __exports__